import { Component, HostListener, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { AppService } from './services/app.service';

import { AuthenticationService } from './services/authentication.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  deferredPrompt: any;
  showBtn = false;
  isHome = false;

  constructor(
    private appService: AppService,
    private authService: AuthenticationService,
    private router: Router
  ) {}
  @HostListener('window:beforeinstallprompt', ['$event'])
  onbeforeinstallprompt(e) {
    // Prevent Chrome 67 and earlier from automatically showing the prompt
    e.preventDefault();
    // Stash the event so it can be triggered later.
    this.deferredPrompt = e;
    this.showBtn = true;
  }

  ngOnInit() {
    //listen to navigation to check if its in home
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (event.url === '/tabs/tab1') {
          this.isHome = true;
        } else {
          this.isHome = false;
        }
      }
    });
    window.addEventListener('appinstalled', (event) => {
      this.showBtn = false;
    });
    const authUser = this.authService.getAuthUser();
    if (authUser !== null && authUser !== undefined) {
      this.appService.authUser = authUser;
      this.authService.authNotifier.next(true);
    } else {
      this.authService.authNotifier.next(false);
    }
  }
  addToHome(e: any) {
    this.deferredPrompt.prompt();
    // Wait for the user to respond to the prompt
    this.deferredPrompt.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === 'accepted') {
        alert('Se procederá a instalar la aplicación');
      } else {
      }
      this.deferredPrompt = null;
    });
  }
}
